import { sql } from "drizzle-orm";
import { jsonb, pgTable, text, unique, uuid } from "drizzle-orm/pg-core";
import { agentTable } from "./agent";
import { numberTimestamp } from "./types";

/**
 * Represents a PostgreSQL table for caching data.
 *
 * @type {pgTable}
 */
export const cacheTable = pgTable(
	"cache",
	{
		id: uuid("id").notNull().primaryKey().default(sql`gen_random_uuid()`),
		key: text("key").notNull(),
		agentId: uuid("agentId")
			.notNull()
			.references(() => agentTable.id, { onDelete: "cascade" }),
		value: jsonb("value").notNull(),
		createdAt: numberTimestamp("createdAt").default(sql`now()`).notNull(),
		expiresAt: numberTimestamp("expiresAt"),
	},
	(table) => [unique("cache_key_agent_unique").on(table.key, table.agentId)],
);
